module.exports = __webpack_public_path__ + "static/media/successful.28d4584c.svg";